import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Alert, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const ActivateAccount = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const token = searchParams.get("token");

  const activatedRef = useRef(false);  // 🛑 ключ

  useEffect(() => {
    const activate = async () => {
      if (activatedRef.current) return;

      try {
        const res = await fetch(`/api/auth/activate?token=${token}`, {
          method: "POST",
        });

        const data = await res.json();
        if (res.ok) {
          activatedRef.current = true;  // ✅ уже активировано
          setMessage(data.message || "✅ Activation complete.");
          setTimeout(() => {
            navigate("/login?activated=true");
          }, 1500);
        } else {
          if (!activatedRef.current) {
            setMessage(data.detail || "❌ Activation failed.");
            setTimeout(() => {
              navigate("/login?expired=true");
            }, 1500);
          }
        }
      } catch {
        if (!activatedRef.current) {
          setMessage("❌ Activation failed.");
          setTimeout(() => {
            navigate("/login?expired=true");
          }, 1500);
        }
      } finally {
        setLoading(false);
      }
    };

    if (token) activate();
    else {
      setMessage("❌ Токен отсутствует.");
      setLoading(false);
      setTimeout(() => {
        navigate("/login?expired=true");
      }, 1500);
    }
  }, [token, navigate]);

  return (<><Helmet> <title>Activate Account - IndexBooster</title></Helmet>
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div style={{ width: "400px", padding: "20px" }}>
        {loading ? <Spinner animation="border" /> : <Alert>{message}</Alert>}
      </div>
    </div>
  </>);
};

export default ActivateAccount;
